import React from 'react';

/**
 * "Powered by Cloud Lab Technologies - UK" attribution shown across the system.
 * Renders a small, accessible link that opens in a new tab with safe rel attrs.
 *
 * Props:
 *  - className: extra tailwind classes to merge (use this to colour for dark/light bg)
 *  - variant: 'inline' (default) | 'block'
 */
const PoweredBy = ({ className = '', variant = 'inline' }) => {
  const wrap = variant === 'block' ? 'block py-2' : 'inline-flex items-center gap-1';
  return (
    <span className={`${wrap} text-xs ${className}`} data-testid="powered-by">
      Powered by{' '}
      <a
        href="https://www.cloudlabweb.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="ml-1 font-semibold underline-offset-2 hover:underline"
        data-testid="powered-by-link"
      >
        Cloud Lab Technologies&nbsp;-&nbsp;UK
      </a>
    </span>
  );
};

export default PoweredBy;
